module.exports = __webpack_public_path__ + "static/media/tanque-cheio-de-premios_375.08b2aae9.png";